module.exports = __webpack_public_path__ + "img/resume.bb31a734.png";